<template>
  <v-row>
    
   <v-row v-if="locations.length > 0">
        <v-col cols="12" class="text-left" sm="12">
           <v-chip   class="ma-2" color="cyan"  label  text-color="white">
              <v-icon left>
                     mdi-map-marker
              </v-icon>
              Searched Locations
           </v-chip>
         <v-chip  class="ma-2"  color="red"  @click="deleteallmapslocation"   label  text-color="white">
      <v-icon left>mdi-trash-can-outline </v-icon>
      Remove All
    </v-chip>
         <ol>
              <li v-for="(item,index) in locations" :value="index" :key="index">
               {{ item.address }} 
                   <!---Country Delete---> 
                    <v-btn  @click="deleteloaction(index,item.countryname)" icon color="red">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                   <!---End Country Delete--->  
                    
              </li> 
         </ol>  
        </v-col>  
      <!--  <v-col cols="2" sm="2" class="text-right">
         
            <v-btn  @click="selectcountryads" color="primary"  class="mx-2"  fab  small  dark >
                <v-icon  title="Clear All Locations">mdi-reload</v-icon>
           </v-btn>       
        </v-col> -->
       </v-row>
   <v-col cols="12" sm="12" class="text-right">
   
      <div>
    <input style="height:30px;width:25%;font-color:#fff;background-color:#929eaa;border-radius:5px;color: #fff;
    left: 4px;
    padding: 10px;
    font-size: 13px;" id="pac-input" class="controls" type="text" placeholder="Search Box">
    <div  id="google-map" ref="googleMap"></div>
    <template v-if="Boolean(google) && Boolean(map)">
      <slot :google="google" :map="map" />
    </template>
     </div>
    
     </v-col>
   
     </v-row>
</template>

<script>
/* global google */
import { Loader } from "@googlemaps/js-api-loader";

import datajson from '../../custom.geo.json';

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default {
  name: "google-map-loader",
  props: {
    mapConfig: {
      required: true,
    },
    getradiusarr :{
    type: Array,
        default: () => []
    },
    getlocationsarr :{
    type: Array,
        default: () => []
    },
    getcountrylist:{
    type: Array,
        default: () => []
    },
    showmapstatus: {
      required: false,
    },
    apiKey:{
      required: true,
    }
  },
  data: function () {
    return {
      google: null,
      map: null,
      mapCircles: [],
      locations: this.getlocationsarr,
      gapikey: this.apiKey,
      getcountrycode :"", 
      getcodestatus:"",
      selectcountry:"",
      searchBox:"",
      countryads:false,
      adscounties:[],
      showgooglemap: true,
      getdatajson:datajson,
      cliclgetaddress :""
    };
  },
  watch: {
    // whenever question changes, this function will run
    getcountrycode() {
         this.getcodestatus = 1;
      //   alert("sdd"+this.getcountrycode);
    }
  },
  methods: {
    deleteloaction(getindex,getcountryname)
    {
    if(this.locations.length > 0)
    {  
    //console.log(feature.admin);
    if(getcountryname !="")
    {
      var getmap = this.map;
      getmap.data.forEach(function (feature) {
         if(feature.getProperty('admin') == getcountryname)
          {
             getmap.data.remove(feature);
          }
         });
      }

      // **Take the circle off the map before letting go of it.**
      //
      // `setMap(null)` used to be commented out on the branch a searched
      // place takes - and every place picked from the search box has a
      // country name, so that was the branch that ran. The entry left the
      // list, the circle stayed drawn, and because it had also been spliced
      // out of `mapCircles` nothing could remove it afterwards: not another
      // delete, not Remove All. Three places were deleted and two red
      // circles stayed on the map with an empty list beside them
      // (2026-11-04).
      //
      // It is the same work whichever branch brought us here, so it is done
      // once, after them.
      if (this.mapCircles[getindex]) {
        this.mapCircles[getindex].setMap(null);
      }
      this.locations.splice(getindex,1);
      this.mapCircles.splice(getindex,1);
    }
     
    },
   deleteallmapslocation(event)
    {
        console.log(event);
     if(this.locations.length > 0)
    {    
      for (let i = 0; i < this.locations.length; i++) {
        if(this.locations[i].countrycode !="")
      {
       
         var getmap = this.map;
       //  let passCountrylat = '';
        this.getdatajson.features.forEach(function () {
                 //  console.log(data);
                 // alert("Test");
                     getmap.data.forEach(function (feature) {
                        getmap.data.remove(feature);
                    });
                     // getmap.data.addGeoJson(passCountrylat);
          });
      } 
      }
     this.locations = [];
     this.removeCircles();
      } 
    },
   selectmapcountry(event) 
    {
      
    var countrycode = event.country_code;
    var countryname = event.country_name;

       var componentRestrictions={};
       componentRestrictions.country=countrycode;
    
    this.searchBox.setComponentRestrictions(componentRestrictions);
    //this.searchBox.set('place',{name:''});
       var    geocoder =   new google.maps.Geocoder();
      //alert(address.toLowerCase());
    
      var getthismap = this.map;
    geocoder.geocode({'address': countryname}, function(results, status) {
      //  this.google.maps.event.addListenerOnce(this.map, 'center_changed');
     //   this.google.maps.event.addListenerOnce(this.map, 'bounds_changed');
       if (status == google.maps.GeocoderStatus.OK) {
          if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
           // alert(countrycode);
            getthismap.setCenter(results[0].geometry.location);//center the map over the result
       
         } else {
            alert("No results found");
          }
        } else {
          alert("Geocode was not successful for the following reason: " + status);
        }

      });



    },
    getfuncountrycode(getcode)
    {
     return  this.getcountrycode = getcode;
    },
     getcirlesarr()
    {
       this.$emit("update:getradiusarr",  this.locations);
    }  ,     
  async  createCircles() {
       for (let i = 0; i < this.locations.length; i++) {
//alert(this.locations[i].latone +"< >"+this.locations[i].langone);
      if(this.locations[i].countrycode !="")
      {   // Here Draw Country Map
         var getmap = this.map;
         var getcountryname = this.locations[i].countryname;
         let passCountrylat = '';
         var getmapCircles = this.mapCircles;
        this.getdatajson.features.forEach(function (value) {
                 //  console.log(data);
                    if(value.properties.name== getcountryname)
                      {
                        passCountrylat = value;
                        getmap.data.addGeoJson(passCountrylat);
                        getmapCircles.push(passCountrylat);
                      }
        
          });
      }else{
        
            var getcirlce = this.locations[i]; 
            const markerCircle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: this.map,
          center: new google.maps.LatLng(
            {
              lat: parseFloat(this.locations[i].lattwo),
              lng: parseFloat(this.locations[i].langtwo),
            },
            null,
            true
          ),
          radius: this.locations[i].radius,
          draggable:true,
          editable : true,
					geodesic: true
        });
        this.mapCircles.push(markerCircle);

  this.google.maps.event.addListener(markerCircle, 'dragend', function() {
     //lat: mapsMouseEvent.latLng.lat(),
           //   lng: mapsMouseEvent.latLng.lng(),
   
      // The circle's own centre, not the pointer: a drag ends wherever the
      // finger was let go, which is near the centre but not it.
      var centre = markerCircle.getCenter();

      getcirlce.radius = markerCircle.getRadius();
      getcirlce.latone = centre.lat();
      getcirlce.langone = centre.lng();
      getcirlce.lattwo = centre.lat();
      getcirlce.langtwo = centre.lng();
  });
 
  this.google.maps.event.addListener(markerCircle, 'radius_changed', function(evt) {
     //lat: mapsMouseEvent.latLng.lat(),
           //   lng: mapsMouseEvent.latLng.lng(),
     console.log('radius_changed' + evt);
   
      // **The circle's centre, not the map's viewport.**
      //
      // This used to read `this.map.getBounds()` and write the viewport's
      // own corners into the coordinate fields, so resizing the circle
      // threw the advertiser's location away and replaced it with wherever
      // the window happened to be looking. A circle drawn over Jodhpur was
      // stored as Gura Vishnoiyan, 16 km away on the edge of the view, and
      // the app then served that advert in a 5.6 km ring around a village
      // the advertiser had never chosen (found 2026-11-04).
      //
      // Resizing a circle does not move it, so the centre is simply read
      // again along with the new radius.
      var centre = markerCircle.getCenter();

      getcirlce.radius = markerCircle.getRadius();
      getcirlce.latone = centre.lat();
      getcirlce.langone = centre.lng();
      getcirlce.lattwo = centre.lat();
      getcirlce.langtwo = centre.lng();
  });
       // this.mapCircles.push(markerCircle);
      }  // End Else
        
      }
        
    },
    removeCircles() {
      for (let i = 0; i < this.mapCircles.length; i++) {
        this.mapCircles[i].setMap(null);
      }
      this.mapCircles = [];
    },
    addlocation(locationid,getradiusvalue)
    {
      this.locations[locationid].radius = getradiusvalue;
    },
  },   
  async mounted() {
    const loader = new Loader({
      apiKey: this.gapikey,
      version: "weekly",
      libraries: ["places"],
      language: "en-US",
    });
    await loader.load();
    this.google = google;
    const mapContainer = this.$refs.googleMap;
    let passCountrylat = '';
    //console.log("mapContainer");
   // console.log(this.mapConfig);
  //  console.log("End mapContainer");
   
    this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
   
   //const trafficLayer = new google.maps.TrafficLayer();
    //  trafficLayer.setMap(this.map)
  //****** Search country drop down **********************/

  //********Country End ***********************************/
  //***********  Search Input Box  */
  
   // Create the search box and link it to the UI element.
  const input = document.getElementById("pac-input");

  
  //const searchBox = new this.google.maps.places.SearchBox(input);
  //const options = {
    //fields: ["formatted_address", "geometry", "name"],
 //   strictBounds: false,
   // types: ["establishment"],
  //};
   this.searchBox = new this.google.maps.places.Autocomplete(input);
  //  this.searchBox.bindTo('bounds',this.map);
/*
    google.maps.event.addListener(list,'change', function(e){
    alert("Test");
    var componentRestrictions={};
    
    if(this.value!==''){
      componentRestrictions.country=this.value
    }
    
    searchBox.setComponentRestrictions(componentRestrictions);
    input.value='';
    if(e){
      searchBox.set('place',{name:''});
    }
          
        
  });  */

  
  

  this.map.controls[this.google.maps.ControlPosition.TOP_LEFT].push(input);

  // Bias the SearchBox results towards current map's viewport.
  this.map.addListener("bounds_changed", () => {
    this.searchBox.setBounds(this.map.getBounds());
  });
 
   // For each place, get the icon, name and location.
    
   // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
   this.searchBox.setFields(['place_id', 'name', 'address_components', 'geometry']);
   /*
   this.google.maps.event.addListener(autocomplete, "place_changed", () => {
  // Custom methods to populate form fields.
    const place = autocomplete.getPlace();
        console.log("places_changed"+place);
      });
  */


     this.google.maps.event.addListener(this.searchBox, "place_changed", () => {
    const place = this.searchBox.getPlace();
    if (place.length == 0) { 
      return;
    }
   //alert(place);
    // For each place, get the icon, name and location.
   // **The circle starts the size of the place the advertiser searched.**
   //
   // These bounds used to be created empty and never filled, so the
   // arithmetic below ran on a degenerate box and produced the same number
   // every time: every banner ever booked was stored with a radius of
   // 5567 m, whether the advertiser had asked for a suburb or a state
   // (found 2026-11-04). Google returns a viewport for a searched place -
   // a city's is the city - which is what the sum was always written for.
   const bounds = new this.google.maps.LatLngBounds();
   if (place.geometry.viewport) {
     bounds.union(place.geometry.viewport);
   } else {
     bounds.extend(place.geometry.location);
   }

       // r = radius of the earth in km
  var r = 6378.8
  // degrees to radians (divide by 57.2958)
  var ne_lat = bounds.getNorthEast().lat() / 57.2958
  var ne_lng = bounds.getNorthEast().lng() / 57.2958
  var c_lat = bounds.getCenter().lat() / 57.2958
  var c_lng = bounds.getCenter().lng() / 57.2958
  // distance = circle radius from center to Northeast corner of bounds
  var r_km = r * Math.acos(Math.sin(c_lat) * Math.sin(ne_lat) + Math.cos(c_lat) * Math.cos(ne_lat) * Math.cos(ne_lng - c_lng)    )
  // A point with no viewport - a shop rather than a town - leaves the two
  // corners equal and the sum at zero. Two kilometres is a sensible ring
  // around an address, and the advertiser can drag the handle either way.
  if (!(r_km > 0)) { r_km = 2 }

        var circleId = this.locations.length;
    //alert(r_km *1000);
       var markerCircle =  new google.maps.Circle({
          strokeColor: "#FF0000",         strokeOpacity: 0.8,          strokeWeight: 2,
          fillColor: "#FF0000",         
           fillOpacity: 0.35,         
            map: this.map,
          label : circleId,          
          center: new google.maps.LatLng(
            {   lat: place.geometry.location.lat(), lng: place.geometry.location.lng(),
            },  null, true
          ),
          // Metres, and the place's own size. It was `r_km * 50`, which is
          // neither kilometres nor metres - it only ever looked plausible
          // because the bounds above were empty and the number constant.
          radius:  r_km * 1000, 
           draggable:true,  editable : true,geodesic: true
          });
            this.mapCircles.push(markerCircle);
       //********** Here Location array *******************/
           var   countrycode = "";
           var   countryname = "";
        //*************  Here Get Country Code */
          if (place.address_components[0].types[0] == "country") {
                  //this is the object you are looking for
                   countrycode = place.address_components[0].short_name;
                   countryname = place.address_components[0].long_name;
                  //getctr.getcodestatus = 1;
                //  this.getcountrycode = countrycode;

                  var getplace = place;
                  var getmap = this.map;
                  this.getdatajson.features.forEach(function (value) {
                            
                              if(value.properties.name== getplace.name)
                                {
                                  passCountrylat = value;
                                  getmap.data.addGeoJson(passCountrylat);
                                }
                  
                    });

                      // **The place's centre, not the corners of its box.**
                      //
                      // These four used to be the viewport's south-west and
                      // north-east corners. The backend stores the pair as
                      // "lat,lat,lon,lon" - one point - so whichever corner
                      // won became the geofence, and the circle the
                      // advertiser saw was never what was saved. Searching
                      // Jodhpur stored 26.18347776700864, the southern edge
                      // of its box, every single time: three bookings made
                      // hours apart carried that latitude to fourteen
                      // decimal places (2026-11-04).
                      //
                      // Google hands back the place's own point, which is
                      // the middle of the circle drawn from it.
                      var country_latone = place.geometry.location.lat();
                      var country_lattwo = place.geometry.location.lat();
                      var country_langone = place.geometry.location.lng();
                      var country_langtwo = place.geometry.location.lng();
                        this.locations.push(
                              {
                                  latone: parseFloat(country_latone),
                                  lattwo: parseFloat(country_lattwo),
                                  langone: parseFloat(country_langone),
                                  langtwo: parseFloat(country_langtwo),
                                  radius: r_km * 1000,
                                  countrycode : countrycode,
                                  countryname : countryname,
                                  address : place.name
                                }
                            );
                      this.getcirlesarr();

              }else{  // this is for city
        //******************************************* */
       
                              // The place's centre, not the corners of its
                              // box - see the note on the country branch
                              // above. This is the one a city search takes.
                              var latone = place.geometry.location.lat();
                              var lattwo = place.geometry.location.lat();
                              var langone = place.geometry.location.lng();
                              var langtwo = place.geometry.location.lng();
                               this.locations.push(
                                      {
                                          latone: parseFloat(latone),
                                          lattwo: parseFloat(lattwo),
                                          langone: parseFloat(langone),
                                          langtwo: parseFloat(langtwo),
                                          radius: r_km * 1000,
                                          countrycode : countrycode,
                                          countryname : countryname,
                                          address : place.name
                                        }
                                    );
                                    
                            //********************************************* */
                                var getcirlce = this.locations;     
                                this.google.maps.event.addListener(markerCircle, 'radius_changed', function() 
                                    { 
                                        // **The circle's centre, not the map's
                                        // viewport** - the same fault as the
                                        // other handler, and this is the one
                                        // that runs when several places are
                                        // searched for one booking. Resizing
                                        // the second circle moved all of its
                                        // coordinates to wherever the window
                                        // was looking (2026-11-04). Resizing
                                        // does not move a circle, so the
                                        // centre is simply read again.
                                        var centre = markerCircle.getCenter();
                                        getcirlce[markerCircle.label].radius = markerCircle.getRadius();
                                        getcirlce[markerCircle.label].latone = centre.lat();
                                        getcirlce[markerCircle.label].langone = centre.lng();
                                        getcirlce[markerCircle.label].lattwo = centre.lat();
                                        getcirlce[markerCircle.label].langtwo = centre.lng();
                                    }); 
                                      var getdragendcirlce = this.locations;     
                                      this.google.maps.event.addListener(markerCircle, 'dragend', function() {
                                        //lat: mapsMouseEvent.latLng.lat(),
                                              //   lng: mapsMouseEvent.latLng.lng(),
                                          // The circle's own centre, not the
                                          // pointer: a drag ends wherever the
                                          // finger was let go.
                                          var centre = markerCircle.getCenter();

                                          getdragendcirlce[markerCircle.label].radius = markerCircle.getRadius();
                                          getdragendcirlce[markerCircle.label].latone = centre.lat();
                                          getdragendcirlce[markerCircle.label].langone = centre.lng();
                                          getdragendcirlce[markerCircle.label].lattwo = centre.lat();
                                          getdragendcirlce[markerCircle.label].langtwo = centre.lng();
                                      });         
                             
                                this.getcirlesarr();

                       
                     }
                      // New code
                            if (place.geometry.viewport) {
                            // Only geocodes have viewport.
                            bounds.union(place.geometry.viewport);
                            } else {
                            bounds.extend(place.geometry.location);
                            }
                          this.map.setZoom(20);
                          this.map.fitBounds(bounds);
         
             
   // End New Code
   /*
   this.map.data.addListener("mouseover", (event) => {
    this.map.data.revertStyle();
    this.map.data.overrideStyle(event.feature, { strokeWeight: 8 });
  });
  */
    
  });

  
  //*********** Search End */
       this.createCircles();
       this.getcirlesarr();
    this.map.addListener("mouseout", () => {
      console.log("mouseout");
    //  this.removeCircles();
    });

   var    geocoder =   new google.maps.Geocoder();
    // Listen for click on map for adding new circle
  this.map.addListener("click", (mapsMouseEvent) => {
					//	this.map.addListener(this.map, 'click', function(event){
           var circleId = this.locations.length;
         //  var getctr= this;
						
//alert(mapsMouseEvent.latLng.lng());

 
					
            const markerCircle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: this.map,
          label : circleId,
          center: new google.maps.LatLng(
            {
              lat: mapsMouseEvent.latLng.lat(),
              lng: mapsMouseEvent.latLng.lng(),
            },
            null,
            true
          ),
          radius: 500,
          draggable:true,
          editable : true,
					geodesic: true

          });

    var meters = 50;
    var earth = markerCircle.getRadius();  //radius of the earth in kilometer
    var latitude = mapsMouseEvent.latLng.lat();
    var longitude = mapsMouseEvent.latLng.lng(),
    pi = Math.PI,
    cos = Math.cos,
    m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree
    var new_latitude = latitude + (meters * m);
    var new_longitude = longitude + (meters * m) / cos(latitude * (pi / 180));

/*
              this.locations.push(
                      {
                          latone: parseFloat(mapsMouseEvent.latLng.lat()) - 0.02,
                          lattwo: parseFloat(mapsMouseEvent.latLng.lat()) ,
                          langone: parseFloat(mapsMouseEvent.latLng.lng()) - 0.02,
                          langtwo: parseFloat(mapsMouseEvent.latLng.lng())  ,
                          radius: markerCircle.getRadius(),
                          countrycode : this.getcountrycode
                        }
                    );
            */
          var get_cliclgetaddress = "";
          var tmp_locationsarr =  this.locations;
          geocoder.geocode({
                'latLng': mapsMouseEvent.latLng
              }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                  if (results[0]) {
                    console.log(results[0].address_components[1]);
                   get_cliclgetaddress = results[0].address_components[1].long_name;
                    if(get_cliclgetaddress !="")
                    { 
                              tmp_locationsarr.push(
                                {
                                    latone: parseFloat(mapsMouseEvent.latLng.lat()),
                                    lattwo: new_latitude ,
                                    langone: parseFloat(mapsMouseEvent.latLng.lng()),
                                    langtwo: new_longitude  ,
                                    radius: markerCircle.getRadius(),
                                    countrycode : "",
                                    address: get_cliclgetaddress
                                  }
                              );
                    }
                  }
                }
              });
          
              var getcirlce = this.locations;     
              this.google.maps.event.addListener(markerCircle, 'radius_changed', function() 
							{ 
                getcirlce[markerCircle.label].radius = markerCircle.getRadius();

                //***************  Make New Lat and Long with increase radius ************** */
              /*
              var   meters = markerCircle.getRadius();
                  latitude = markerCircle.latLng.lat();
                  longitude = markerCircle.latLng.lng();
                  getcirlce[markerCircle.label].latone = latitude; 
                  getcirlce[markerCircle.label].langone = longitude; 
                  new_latitude = latitude + (meters * m);
                  new_longitude = longitude + (meters * m) / cos(latitude * (pi / 180));  
               //   alert(new_latitude +" "+ new_longitude);
                 getcirlce[markerCircle.label].lattwo = new_latitude; 
                 getcirlce[markerCircle.label].langtwo = new_longitude; 
                  */
/*
                  var latone = parseFloat(mapsMouseEvent.latLng.lat());
                  var lattwo = parseFloat(mapsMouseEvent.latLng.lat());
                  var langone = parseFloat(mapsMouseEvent.latLng.lng());
                  var langtwo = parseFloat(mapsMouseEvent.latLng.lng());

                   getcirlce[markerCircle.label].latone = latone; 
                   getcirlce[markerCircle.label].lattwo = lattwo;
                   getcirlce[markerCircle.label].langone = langone; 
                   getcirlce[markerCircle.label].langtwo = langtwo;
                    */
                //***************************************************************************** */
              }); 
              var getdragendcirlce = this.locations;     
                this.google.maps.event.addListener(markerCircle, 'dragend', function() {
               getdragendcirlce[markerCircle.label].radius = markerCircle.getRadius();
    console.log('dragend 2');
                //***************  Make New Lat and Long with increase radius ************** */
             /*
             var   meters = markerCircle.getRadius();
              var    latitude = markerCircle.latLng.lat();
              var    longitude = markerCircle.latLng.lng();

                  getdragendcirlce[markerCircle.label].latone = latitude; 
                  getdragendcirlce[markerCircle.label].langone = longitude; 

                  new_latitude = latitude + (meters * m);
                  new_longitude = longitude + (meters * m) / cos(latitude * (pi / 180));  
               //   alert(new_latitude +" "+ new_longitude);
                 getdragendcirlce[markerCircle.label].lattwo = new_latitude; 
                 getdragendcirlce[markerCircle.label].langtwo = new_longitude; 
                  */

                 var latone = parseFloat(mapsMouseEvent.latLng.lat());
                  var lattwo = parseFloat(mapsMouseEvent.latLng.lat());
                  var langone = parseFloat(mapsMouseEvent.latLng.lng());
                  var langtwo = parseFloat(mapsMouseEvent.latLng.lng());


                 getdragendcirlce[markerCircle.label].latone = latone; 
                 getdragendcirlce[markerCircle.label].lattwo = lattwo; 
                 getdragendcirlce[markerCircle.label].langone = langone; 
                 getdragendcirlce[markerCircle.label].langtwo = langtwo; 
                //***************************************************************************** */

                });   
             
           this.mapCircles.push(markerCircle);
              this.getcirlesarr();

							});
  },
};
</script>
<style lang="scss" scoped>
#google-map {
  width: 100%;
  min-height: 100%;
  height: 312px;
}
 ol {
   list-style: none;
   counter-reset: item;
   padding-left:10px;
 }
 li {
   counter-increment: item;
   margin-bottom: 5px;
 }
 li:before {
   margin-right: 10px;
   content: counter(item);
   background: #5fa1b7;
   border-radius: 100%;
   color: white;
   width: 1.2em;
   text-align: center;
   display: inline-block;
 }
</style>